import React from 'react';

interface CataxIconProps {
  className?: string;
  size?: number;
  animated?: boolean;
}

const CataxIcon: React.FC<CataxIconProps> = ({ className = "", size = 24, animated = false }) => {
  return (
    <svg
      className={className}
      viewBox="0 0 126.266 225.084"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Cata Logo"
    >
      <g className={animated ? 'animate-[pulse_3s_ease-in-out_infinite]' : ''}>
        <path d="M0 110.151C0 109.536 0.274938 108.953 0.749564 108.562L62.5104 57.6736C63.8534 56.5671 65.8783 57.5224 65.8783 59.2625V114.933C65.8783 115.548 65.6033 116.131 65.1287 116.522L3.36784 167.411C2.02489 168.517 0 167.562 0 165.822V110.151Z" fill="#201E1A" />
        <path d="M126.266 55.2522C126.266 54.6372 125.991 54.0544 125.516 53.6633L63.7552 2.77496C62.4122 1.66843 60.3874 2.6237 60.3874 4.3638V60.0348C60.3874 60.6498 60.6623 61.2326 61.1369 61.6236L122.898 112.512C124.241 113.619 126.266 112.663 126.266 110.923V55.2522Z" fill="#201E1A" />
        <path d="M126.266 165.049C126.266 164.434 125.991 163.851 125.516 163.46L63.7552 112.572C62.4122 111.465 60.3874 112.421 60.3874 114.161V169.832C60.3874 170.447 60.6623 171.029 61.1369 171.42L122.898 222.309C124.241 223.415 126.266 222.46 126.266 220.72V165.049Z" fill="#201E1A" />
      </g>
    </svg>
  );
};

export default CataxIcon;
